/*jslint node: true, browser: true*/
"use strict";

var $ = require("pli/jquery");
var clientBroadcastManager = require("pli/clientbroadcastmanager");
var ko = require("pli/knockout");
var picklistBehaviour = require("pli/forms-knockoutcontrols-picklist");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");
var viewModelInit = require("pli/forms-viewmodel");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");

require("./contactViewModel.js");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Private
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function filterPicklist(pickListData, filter) {
    /// <summary>
    /// Filters picklist data items
    /// </summary>

    if (!pickListData || !pickListData.items) { throw new Error("picklistData is expected to be an pickListData object"); }
    if (typeof filter !== "function") { throw new Error("filterPicklist is expected to be a function"); }

    var group, ind, i, j, item, index, newItems = [],
        data = $.extend(true, {}, pickListData),
        newIndices = $.extend(true, {}, data.indices);

    // clear lenght of groups
    for (group in data.groups) {
        if (data.groups.hasOwnProperty(group)) {
            for (i = 0; i < data.groups[group].length; i += 1) {
                data.groups[group][i].length = 0;
            }
        }
    }

    // filter data items
    for (i = 0; i < data.items.length; i += 1) {

        item = data.items[i];
        item.dataIndex = newItems.length + 1; // update item dataIndex

        if (filter(item)) {
            // add new item
            newItems.push(item);

            // fix group length
            for (group in data.groups) {
                if (data.groups.hasOwnProperty(group)) {
                    for (j = 0; j < data.groups[group].length; j += 1) {
                        if (item[group] === data.groups[group][j].name) {
                            data.groups[group][j].length += 1;
                        }
                    }
                }
            }

            // change indicies
            for (ind in data.indices) {
                if (data.indices.hasOwnProperty(ind)) {
                    index = ko.utils.arrayIndexOf(newIndices[ind], i);
                    if (index >= 0) {
                        newIndices[ind][index] = newItems.length - 1;
                    }
                }
            }
        } else {
            // remove indicies
            for (ind in data.indices) {
                if (data.indices.hasOwnProperty(ind)) {
                    index = ko.utils.arrayIndexOf(newIndices[ind], i);
                    if (index >= 0) {
                        newIndices[ind].splice(index, 1);
                    }
                }
            }
        }
    }

    // set filterd items and inicies
    data.items = newItems;
    data.indices = newIndices;
    data.count = newItems.length;

    return data;
}



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ContactAcquireDetailsViewModel
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function ContactAcquireDetailViewModel() {
    this.id = ko.observable();
    this.code = ko.observable();
    this.mainContactValue = ko.observable();
    this.acquireContactValue = ko.observable();
}

//-------------------------------------------
ContactAcquireDetailViewModel.prototype.loadViewModel = function loadContactAcquireDetailViewModel(record) {
    this.id(record.id || "");
    this.code(record.code);
    this.mainContactValue(record.mainContactValue);
    this.acquireContactValue(record.acquireContactValue);
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ContactAcquireViewModel
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function ContactAcquireViewModel(form, factories) {

    this.contact = pliObservable(null, dataCache.getObservable("contact"), picklistBehaviour, "required"); // main contact
    this.acquireContact = pliObservable(null, ko.observable({ picklistData: entityRegistry.contact.getPicklistBehaviourData().picklistData().data }), picklistBehaviour, "required"); // acquire contact
    this.removeAfterAcquire = ko.observable(false);
    this.remark = pliObservable(null); // acquire remark

    // private actions
    this._updateUsagesCount = ContactAcquireViewModel.prototype._updateUsagesCount.bind(this);
    this._acquireCompleteHandler = ContactAcquireViewModel.prototype._acquireCompleteHandler.bind(this);
    this._exportingStartHandler = ContactAcquireViewModel.prototype._exportingStartHandler.bind(this);
    this._exportingStatusUpdateHandler = ContactAcquireViewModel.prototype._exportingStatusUpdateHandler.bind(this);

    // non-serialized properties
    this.extras = function ContactAcquireViewModelExtras() { return; };
    this.extras.form = form;
    this.extras.state = ko.observable("ready");
    this.extras.displayName = ko.observable();
    this.extras.values = factories.details.createObservableArray(); // details list
    this.extras.usagesCount = ko.observable(0); // usages count
    this.extras.errorsCount = ko.observable(0); // validation errors count
    this.extras.acquiresLabel = ko.observable("Acquires");
    this.extras.showInfoMessage = ko.observable(false);
    this.extras.oldAcquireContact = ko.observable("Contact");

    this.extras.progressMessage = ko.computed(ContactAcquireViewModel.prototype._getProgressMessage, this);
    this.extras.progressIconClass = ko.computed(ContactAcquireViewModel.prototype._getProgressIconClass, this);

    // subscriptions
    this.extras._contactChanged = this.contact.item.subscribe(ContactAcquireViewModel.prototype._contactChanged, this);
    this.extras._acquireContactChanged = this.acquireContact.subscribe(ContactAcquireViewModel.prototype._updateInfo, this);

    // register keymap
    pli.keys.registerKeymap(this.extras.form.id,
        ko.utils.extend(
            ko.utils.extend({}, pli.config.defaultKeymap),
            {
                "Close": this.close
            }
        ));
    this.extras.form.page.keymap = this.extras.form.id;
}


//-------------------------------------------
ContactAcquireViewModel.prototype.init = function initContactAcquireViewModel(contact) {
    /// <summary>
    /// Sets initial values
    /// </summary>

    // set main contact
    this.contact(contact);

    this.reset();
};

//-------------------------------------------
ContactAcquireViewModel.prototype.reset = function resetContactAcquireViewModel() {
    /// <summary>
    /// Reset view
    /// </summary>

    // default values
    this.removeAfterAcquire(false);
    this.remark(null);

    // reset acquire contact
    this.acquireContact.reset();

    // set status
    this.extras.state("ready");
};

//-------------------------------------------
ContactAcquireViewModel.prototype.open = function openContactAcquireViewModel(contact) {
    /// <summary>
    /// Opens acquire contact form
    /// </summary>

    this.init(contact);

    // bind the form if it is not already
    if (!this.isBound) {
        ko.applyBindings(this, this.extras.form.$form[0]);
        this.isBound = true;
    }

    // show the inline form
    pli.forms.open(this.extras.form.id);

    return false;// prevent default behaviour
};


//-------------------------------------------
ContactAcquireViewModel.prototype.close = function closeContactAcquireViewModel(force) {
    /// <summary>
    /// Closes form if the form is
    /// not busy (unless forced).
    /// </summary>

    if (force || this.extras.state().indexOf("active") < 0) {
        // Reset info message
        this.extras.oldAcquireContact("Contact");
        this.extras.showInfoMessage(false);

        pli.forms.close(this.extras.form.id);
    }
    return false; // prevent default behaviour
};


//-------------------------------------------
ContactAcquireViewModel.prototype.loadUsages = function loadUsagesContactAcquireViewModel() {
    this.extras.state("selected.active");
    pli.call({
        name: "Geo-Contact-GetUsagesCount",
        data: { contact: this.acquireContact() }
    }).always(this._updateUsagesCount);
};


//-------------------------------------------
ContactAcquireViewModel.prototype.acquire = function acquireContactAcquireViewModel() {
    /// <summary>
    /// Acquire contacts
    /// </summary>
    this.extras.state("acquisition.active");
    pli.call({
        name: "Geo-Contact-Acquire",
        jsonData: ko.toJSON(this)
    }).always(this._acquireCompleteHandler);
};


//-------------------------------------------
ContactAcquireViewModel.prototype.exportUsages = function exportUsagesContactAcquireViewModel() {
    /// <summary>
    /// Exports usages
    /// </summary>
    this.extras.state("exporting.active");
    pli.call({
        name: "Geo-Report-Start",
        data: { reportId: "ContactUsages", reportData: this.acquireContact() }
    }).always(this._exportingStartHandler);
};


//-------------------------------------------
ContactAcquireViewModel.prototype._contactChanged = function contactChangedContactAcquireViewModel(contactItem) {

    this.extras.acquiresLabel(contactItem ? contactItem[0] + " acquires" : "Acquires");

    if (contactItem) {
        // filter list of contacts to exclude
        var contactPicklist = dataCache.getObservable("contact"),
            data = filterPicklist(contactPicklist().data, function (item) {
                return item[0] !== contactItem[0];
            });

        // update picklistData
        this.acquireContact.behaviourData().data = data;
        this.acquireContact.behaviourData.valueHasMutated();

        // update info
        this._updateInfo();
    }
};

//-------------------------------------------
ContactAcquireViewModel.prototype._updateInfo = function updateInfoContactAcquireViewModel() {
    /// <summary>
    /// Updates information about contact and acquire contact
    /// </summary>

    // set display name
    this.extras.displayName(this.contact().concat(" acquires ").concat(this.acquireContact() || "..."));

    if (this.acquireContact()) {
        // new contact selected, hide info message
        this.extras.showInfoMessage(false);

        var contactItem = this.contact.item() || new Array(7),
            acquireItem = this.acquireContact() ? this.acquireContact.item() : new Array(7);

        // set values grid data
        this.extras.values.loadViewModel([
            { code: "Description", mainContactValue: contactItem[2], acquireContactValue: acquireItem[2] },
            { code: "Phone", mainContactValue: contactItem[3], acquireContactValue: acquireItem[3] },
            { code: "Fax", mainContactValue: contactItem[4], acquireContactValue: acquireItem[4] },
            { code: "Type", mainContactValue: contactItem[1], acquireContactValue: acquireItem[1] }
        ]);

        // if acquire contact is selected - load usages count
        this.loadUsages();
    } else {
        this.extras.state("ready");
    }
};


//-------------------------------------------
ContactAcquireViewModel.prototype._getProgressMessage = function getProgressMessageContactAcquireViewModel() {

    switch (this.extras.state()) {
    case "exporting.active":
        return "Generating file with usages of " + this.acquireContact() + "...";
    case "selected.active":
        return "Loading usages of " + this.acquireContact() + "...";
    case "selected.error":
        return "Failed to load usages of " + this.acquireContact();
    case "selected.done":
        return (this.extras.usagesCount() > 0 ? this.extras.usagesCount() : "No") + " usages of " + this.acquireContact() + " found";
    case "selected.validationError":
        return (this.extras.usagesCount() > 0 ? this.extras.usagesCount() : "No") + " usages of " + this.acquireContact() + " found "
                + (this.extras.errorsCount() > 0 ? "but " + this.extras.errorsCount() + " validation error(s) exist." : "");
    case "acquisition.active":
        return this.contact() + " is acquiring " + this.acquireContact() + "...";
    case "acquisition.error":
        return "Failed to acquire " + this.acquireContact();
    case "acquisition.done":
        return this.contact() + " successfully acquired " + this.acquireContact();
    default:
        return "";
    }
};


//-------------------------------------------
ContactAcquireViewModel.prototype._getProgressIconClass = function getProgressIconClassContactAcquireViewModel() {

    switch (this.extras.state()) {
    case "selected.active":
    case "acquisition.active":
    case "exporting.active":
        return "sprite-progress-15 sprite-spin";
    case "selected.error":
    case "acquisition.error":
    case "exporting.error":
        return "sprite-warning-16";
    case "selected.validationError":
        return "sprite-x-16";
    case "selected.done":
    case "acquisition.done":
    case "exporting.done":
        return "sprite-checked-16";
    default:
        return "";
    }
};


//-------------------------------------------
ContactAcquireViewModel.prototype._acquireCompleteHandler = function acquireCompleteHandlerContactAcquireViewModel(response) {
    /// <summary>
    /// Handles acquire process completness
    /// </summary>
    if (response.isError) {
        this.extras.state("acquisition.error");
    } else {
        this.extras.state("acquisition.done");
        if (this.removeAfterAcquire()) {
            this.extras.oldAcquireContact(this.acquireContact());
            this.reset();
            this.extras.showInfoMessage(true);
        }
    }
};


//-------------------------------------------
ContactAcquireViewModel.prototype._exportingStartHandler = function exportingeStartHandlerContactAcquireViewModel(response) {
    /// <summary>
    /// Handles exporting process start
    /// </summary>
    if (response.isError) {
        this.extras.state("exporting.error");
    } else {
        if (response.result) {
            // set token
            this.extras.exportToken = response.result.token;
            // subscribe
            clientBroadcastManager.onUpdated(this._exportingStatusUpdateHandler);
        }
    }
};


//-------------------------------------------
ContactAcquireViewModel.prototype._exportingStatusUpdateHandler = function exportingStartHandlerContactAcquireViewModel(result) {
    /// <summary>
    /// Handles export status change
    /// </summary>
    if (result.data && result.data.token === this.extras.exportToken) {
        if (result.data.status === 2) { // completed
            if (this.extras.errorsCount() > 0) {
                this.extras.state("selected.validationError");
            } else {
                this.extras.state("selected.done"); // set status to ready to acquire again
            }
            window.location = pli.resolveUrl("~/Reports/Download/" + this.extras.exportToken + "?forceDownload=true"); // force download the file
        } else if (result.data.status === 4) { // failed
            this.extras.state("exporting.error");
        }

        if (result.data.status !== 1) { // status is not generating anymore - unsubscribe from BroadcastManager messages
            clientBroadcastManager.offUpdated(this._exportingStatusUpdateHandler);
        }
    }
};


//-------------------------------------------
ContactAcquireViewModel.prototype._updateUsagesCount = function updateUsagesCountContactAcquireViewModel(response) {
    /// <summary>
    /// Updates usages count
    /// </summary>
    if (response.isError || response.result === undefined) {
        this.extras.state("selected.error");
    } else {
        this.extras.usagesCount(response.result.usagesCount);
        if (response.result.errorsCount) {
            this.extras.errorsCount(response.result.errorsCount);
            this.extras.state("selected.validationError");
        } else if (this.extras.state() === "selected.active") { // change the state to done only if state is active
            this.extras.state("selected.done");
        }
    }
};


//-------------------------------------------
ContactAcquireViewModel.prototype.resolveContainerCssWithState = function resolveContainerCssWithStateForPicklist() {
    /// <summary>
    /// Computes composite container CSS by combining
    /// base CSS (_containerCss) with one CSS class
    /// per state segment (i.e. "my.segmented.value"
    /// would produce "withStateMy", "withStateSegmented",
    /// "withStateValue").
    /// </summary>
    //-------------------------------------------
    var i, l,
        stateItems = this.extras.state().split(".");
    for (i = 0, l = stateItems.length; i < l; i += 1) {
        stateItems[i] = "withState".concat(stateItems[i][0].toUpperCase(), stateItems[i].substring(1));
    }
    return stateItems.join(" ");
};


//-------------------------------------------
ContactAcquireViewModel.prototype.isAcquireEnabled = function isAcquireEnabledContactAcquireViewModel() {
    return this.extras.state() !== 'ready'
        && this.extras.state() !== 'acquisition.active'
        && this.extras.state() !== 'exporting.active'
        && this.extras.state() !== 'acquisition.done'
        && this.extras.state() !== 'selected.validationError'
        && this.extras.state() !== 'selected.active';
};


//-------------------------------------------
ContactAcquireViewModel.prototype.isAcquiring = function isAcquiringContactAcquireViewModel() {
    return this.extras.state() === 'acquisition.active'
        || this.extras.state() === 'exporting.active'
        || this.extras.state() === 'acquisition.done';
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// find contact acquire form
var contactAcquireForm = pli.forms.registry.contactAcquireForm;
if (contactAcquireForm === null || typeof contactAcquireForm !== "object") { throw new Error("Acquire Contact form element could not be found - did you render it using CreateContactAcquireForm?"); }

// factories
viewModelInit.createContactAcquireFactories = function createContactAcquireFactories() {
    return {
        details: viewModelInit.createGridViewModelFactory({ computeErrorsCount: viewModelInit.computeErrorsCount }, ContactAcquireDetailViewModel, null, 2)
    };
};

// set contact Acquire form viewModel
contactAcquireForm.viewModel = new ContactAcquireViewModel(contactAcquireForm, viewModelInit.createContactAcquireFactories(contactAcquireForm.id));
contactAcquireForm.open = contactAcquireForm.viewModel.open;


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = ContactAcquireViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/picklist-contact/contactAcquireViewModel.js
// module id = 569
// module chunks = 49